export const SETORDERNOLIST = "SETORDERNOLIST";
export const SETFILTERVENDORLIST = "SETFILTERVENDORLIST";
export const SETPURCHASEORDERLIST = "SETPURCHASEORDERLIST";
export const SETPRJLIST = "SETPRJLIST";
export const SETWHSELIST = "SETWHSELIST";
export const SETTAXLIST = "SETTAXLIST";
export const SETCOSTCENTERLIST = "SETCOSTCENTERLIST";
export const SETPAYTERMSLIST = "SETPAYTERMSLIST";
export const SETSUPPLYLIST = "SETSUPPLYLIST";
export const CLEARDOC = "CLEARDOC";
export const SETITEMLIST = "SETITEMLIST";
export const SETITEMS = "SETITEMS";
export const SETVENDORLIST = "SETVENDORLIST";
export const SETVENDORADDRESS = "SETVENDORADDRESS";
export const SETVENDORADDRESSLIST = "SETVENDORADDRESSLIST";
export const SETSERIESLIST = "SETSERIESLIST";
export const SETHSNLIST = "SETHSNLIST";
export const SETPURCHASEORDER = "SETPURCHASEORDER";
export const SETATTACHMENTLIST = "SETATTACHMENTLIST";
export const SETADVANCEFILTERLIST = "SETADVANCEFILTERLIST";
export const SETITEMINFO = "SETITEMINFO";
export const SETVENDORINFO = "SETVENDORINFO";
export const SETDUPLICATEDOC = "SETDUPLICATEDOC";
export const SETDEFAULTCURRENCY = "SETDEFAULTCURRENCY";
export const SETPURCHASEORDERBASICFILTERDATA = "SETPURCHASEORDERBASICFILTERDATA";
export const SETEMAILCONTENT = "SETEMAILCONTENT";
export const SETCOMPANYADDRESS = "SETCOMPANYADDRESS";
export const SETWHSADDRESS = "SETWHSADDRESS";
